import type { Api, Features } from "@rhema/client";
import { useEffect, useState } from "react";
import { useApi } from "./session";

// One request per server for the life of the app. Desktop and mobile can point at another server,
// so the answer is kept for each Api.
const asked = new WeakMap<Api, Promise<Features>>();

export function loadFeatures(api: Api): Promise<Features> {
  let found = asked.get(api);
  if (!found) {
    found = api.features();
    asked.set(api, found);
  }
  return found;
}

/**
 * The server's switches, or null until they arrive. Treat null as everything off, so a screen
 * never offers a feature the server may not have.
 */
export function useFeatures(): Features | null {
  const api = useApi();
  const [features, setFeatures] = useState<Features | null>(null);
  useEffect(() => {
    let live = true;
    void loadFeatures(api).then((f) => live && setFeatures(f));
    return () => {
      live = false;
    };
  }, [api]);
  return features;
}

/** Whether phone sign-in and finding people by number are on for this server. */
export function usePhoneEnabled(): boolean {
  return useFeatures()?.phone === true;
}
